// 设置的 utm 信息
export const UTM_STR = "QDReport_utm";
// organic referral
export const ORGANIC_REFERRER = "organic-referrer";

// cookie & localstorage items
export const LS_HISTORY_SEARCH = "chereads.history_search";

// 本地阅读记录
export const LS_READING_HISTORY = "chereads.reading_history";

// cookie 记录 session 信息
export const CR_SESSION_ID = "sid";
